// Site-wide SEO configuration
export const SITE_CONFIG = {
  siteName: 'Antiquaire Expert Paris',
  siteUrl: 'https://www.antiquaires-experts.fr',
  defaultTitle: 'Antiquaire Expert Paris | Expertise & Rachat Antiquites',
  defaultDescription: 'Antiquaire expert a Paris. Estimation gratuite, rachat d\'antiquites, bijoux, mobilier ancien. Deplacement gratuit en Ile-de-France. Tel: 06 58 08 45 16',
  phone: '06 58 08 45 16',
};

// Title template for consistent formatting
export const formatTitle = (pageTitle) => {
  if (!pageTitle) return SITE_CONFIG.defaultTitle;
  return `${pageTitle} | Antiquaire Expert Paris`;
};
